import { useState } from "react";

// Small round avatar — renders the persona photo when a tenant supplies one
// AND it loads; otherwise an initial-circle fallback (TES-485: the portrait
// lives on our media platform and may not be uploaded yet — never render a
// broken image). Used in the patient chat pane to mark who sent each message
// (coach / doctor). The identity (name + optional photo) comes from the
// generic tenant-level persona config, never a per-row name.

interface AvatarProps {
  name: string;
  src?: string;
  /** Pixel diameter. */
  size?: number;
  /** Tailwind classes for the initial-circle fallback (bg + text colour). */
  toneClassName?: string;
}

export function Avatar({
  name,
  src,
  size = 28,
  toneClassName = "bg-brand/15 text-brand",
}: AvatarProps) {
  const [failed, setFailed] = useState(false);
  const initial = name.trim().charAt(0).toUpperCase() || "?";
  const dimension = { width: size, height: size };

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={name}
        style={dimension}
        onError={() => setFailed(true)}
        className="shrink-0 rounded-full object-cover"
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      title={name}
      style={dimension}
      className={`inline-flex shrink-0 items-center justify-center rounded-full text-xs font-semibold ${toneClassName}`}
    >
      {initial}
    </span>
  );
}
